module.exports = __webpack_public_path__ + "static/img/aaron_plus_wx.2bf3ce7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aaron_plus_wx.jpg
// module id = lbga
// module chunks = 1